import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Card from "react-bootstrap/esm/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import toast, { Toaster } from "react-hot-toast";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import BackToGameList from "../../utils/BackToGameList";

function OddOneOut() {
  const [number, setNumber] = useState(4);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [time, setTime] = useState(60);
  const [pairs, setPairs] = useState([]);
  const [oddOne, setOddOne] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [items, setItems] = useState([]);
  const [guess, setGuess] = useState();
  const [play, setPlay] = useState(false);
  const [gO, setGO] = useState(false);
  const [gameComplete, setGameComplete] = useState(false);
  const [intervalID, setIntervalID] = useState();

  const handleItems = async () => {
    const response = await makeGetRequest(
      urls.getIcons + "?active=True",
      "",
      true
    );
    setItems(
      response.data
        .map((data) => {
          return { value: data, id: Math.random() };
        })
        .sort((a, b) => a.id - b.id)
        .map((n) => {
          return n.value;
        })
    );
  };

  const startGame = () => {
    setPlay(true);
    setGO(false);
    setGameComplete(false);
    for (let i = 0; i < number; i++) {
      pairs.push(
        <Col key={i} xs={4} style={{ textAlign: "center" }}>
          <Button
            key={i}
            style={{
              margin: "10px",
              width: "350px",
            }}
            variant="secondary"
            onClick={() => setGuess(i)}
          >
            <img
              src={items[i].image}
              style={{ width: "256px", height: "256px" }}
            />
          </Button>
        </Col>
      );
      pairs.push(
        <Col key={i + "p"} xs={4} style={{ textAlign: "center" }}>
          <Button
            key={i}
            style={{
              margin: "10px",
              width: "350px",
            }}
            variant="secondary"
            onClick={() => setGuess(i)}
          >
            <img
              src={items[i].image}
            style={{ width: "256px", height: "256px" }}
            />
          </Button>
        </Col>
      );
    }
    pairs.push(
      <Col key={"oddOne"} xs={4} style={{ textAlign: "center" }}>
        <Button
          key={"oddOne"}
          style={{
            margin: "10px",
            width: "350px",
          }}
          variant="secondary"
          onClick={() => setGuess("oddOne")}
        >
          <img
            src={items[number + 1].image}
            style={{ width: "256px", height: "256px" }}
          />
        </Button>
      </Col>
    );
    setButtons(
      pairs.map((pairButtons) => {
        return { value: pairButtons, id: Math.random() };
      })
    );
  };

  const oddOneCheck = (z) => {
    console.log(z);
    if (z !== "newGame" && z !== null && z !== undefined) {
      if (z === "oddOne") {
        setPlay(false);
        toast(
          "Congratulations, you've completed the game! Click the Restart button to do it all again. Number of incorrect attempts: " +
            incorrectCount,
          {
            duration: 5000,
            position: "bottom-center",
          }
        );
        setGameComplete(true);
        setTime(60);
        setPairs([]);
        setGuess("newGame");
      } else {
        toast("Sorry but that is incorrect. Please try again!", {
          duration: 5000,
          position: "bottom-center",
        });
        setIncorrectCount((prevCount) => prevCount + 1);
        setGuess("newGame");
      }
    }
  };

  useEffect(() => {
    oddOneCheck(guess);
  }, [guess]);

  useEffect(() => {
    if (play) {
      const intervalId = setInterval(() => {
        if (play) {
          setTime((prevSeconds) => prevSeconds - 1);
        }
      }, 1000);
      setIntervalID(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [play]);

  const gameOver = () => {
    setTime(60);
    setPairs([]);
    setPlay(false);
    setGO(true);
    setItems([]);
    handleItems();
  };

  useEffect(() => {
    if (time <= 0) {
      gameOver();
    }
  }, [time]);

  useEffect(() => {
    setItems([]);
    handleItems();
  }, [play]);

  return (
    <>
      <BackToGameList />
      {pairs.length < 1 ? (
        <Card style={{ marginTop: "5px" }}>
          <Card.Header style={{ textAlign: "center", fontSize: "24px" }}>
            <b>Odd One Out</b>
          </Card.Header>
          <Card.Body style={{ textAlign: "center" }}>
            {gO
              ? <h2>Looks like you ran out of time! Don't fret, to play again touch the Restart Game button below. Select the image that does NOT have a pair to win!</h2>
              : gameComplete === false
              ? <><h3>Look at the group of things.
                Most things are in pairs (two that match).
                One thing does not have a pair.
                Find the one that does not have a pair.
                Point to it or say which one is the odd one out!</h3>
                <br /><br />
                <h5>Example:
                🍎 Apple, 🚗 Car, 📺 TV, 📺 TV, 🚗 Car
                Which one is the odd one out?
                (The Apple! Because it does not have a pair.)</h5></>
              : <h2>
                  🎉 Great job! You found the odd one out! You win! 🎉
                  <br />
                  To play again, click the Start Game button below.
                </h2>}
            <br />
            <Button size="lg" onClick={startGame}>
              {!gO ? "Start Game" : "Restart Game"}
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <Card style={{ paddingBottom: "25px", marginTop: "5px" }}>
          <Row>
            <Col
              style={{
                textAlign: "center",
                marginTop: "5px",
                marginBottom: "15px",
              }}
            >
              <h1
                style={{
                  border: "#333 solid 1px",
                  borderRadius: "25px",
                  width: "400px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                Time Remaining: {time}
              </h1>
            </Col>
          </Row>
          <Row>
            {buttons
              .map((b) => b)
              .sort((a, b) => a.id - b.id)
              .map((n) => {
                return n.value;
              })}
          </Row>
        </Card>
      )}
    </>
  );
}

export default OddOneOut;
